import * as React from "react";
import { SVGProps } from "react";
export const ArrowRightUpIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        width="1em"
        height="1em"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M3.93799 16.042C3.75733 15.8613 3.66699 15.653 3.66699 15.417C3.66699 15.1803 3.75733 14.972 3.93799 14.792L12.812 5.91699H8.33299C8.09699 5.91699 7.89233 5.82999 7.71899 5.65599C7.54499 5.48266 7.45799 5.27799 7.45799 5.04199C7.45799 4.80599 7.54499 4.60099 7.71899 4.42699C7.89233 4.25366 8.09699 4.16699 8.33299 4.16699H14.938C15.174 4.16699 15.3787 4.25366 15.552 4.42699C15.7253 4.60099 15.812 4.80599 15.812 5.04199V11.646C15.812 11.882 15.7253 12.0867 15.552 12.26C15.3787 12.434 15.174 12.521 14.938 12.521C14.7013 12.521 14.4963 12.434 14.323 12.26C14.149 12.0867 14.062 11.882 14.062 11.646V7.14599L5.14599 16.062C4.96533 16.2427 4.76033 16.326 4.53099 16.312C4.30233 16.2987 4.10466 16.2087 3.93799 16.042Z"
            fill="currentColor"
        />
    </svg>
);
ArrowRightUpIcon.displayName = "ArrowRightUpIcon";
